"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listTransactionsResponseSchema = exports.listTransactionsQuerySchema = exports.MerchantTransactionTypeSchema = exports.listTransactionsParamsSchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("../base/common.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// MERCHANT TRANSACTIONS SCHEMAS
// ============================================
// Common merchant params schema
const _MerchantParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// Params schemas for each endpoint
exports.listTransactionsParamsSchema = _MerchantParamsSchema;
// Transaction types (FR96-100)
const _MerchantTransactionTypeSchema = zod_1.z.enum([
    'redemption', // FR96: Coupon used
    'prepaid_deposit', // FR97: Cash deposit
    'credit_adjustment', // FR98: Manual balance change
    'credit_usage', // FR99: Customer paid with credit
    'refund', // FR100: Reversed transaction
]);
// Export for external use
exports.MerchantTransactionTypeSchema = _MerchantTransactionTypeSchema;
// GET /merchants/:merchantId/transactions - Query (FR95, FR154-157)
exports.listTransactionsQuerySchema = zod_1.z.object({
    type: _MerchantTransactionTypeSchema.optional(), // FR154
    startDate: timestamp_schemas_1.timestampIsoSchema.optional(), // FR155
    endDate: timestamp_schemas_1.timestampIsoSchema.optional(),
    userId: common_schemas_1.uuidSchema.optional(), // FR156
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
    cursor: zod_1.z.string().optional(),
});
// Internal schema for transaction item in list
const _TransactionItemSchema = zod_1.z.object({
    transaction_id: zod_1.z.number().int(),
    type: _MerchantTransactionTypeSchema,
    amount: common_schemas_1.signedMoneyAmountSchema, // Positive = money in, negative = money out
    user_id: zod_1.z.string(),
    user_display_name: zod_1.z.string().nullable(),
    description: zod_1.z.string(),
    timestamp: timestamp_schemas_1.timestampIsoSchema,
    // For redemptions - link to refund action (FR159)
    is_refundable: zod_1.z.boolean().optional(),
    redemption_id: zod_1.z.number().int().nullable(),
});
// GET /merchants/:merchantId/transactions - Response
exports.listTransactionsResponseSchema = (0, api_schemas_1.listResponseSchema)(_TransactionItemSchema);
